import styled from 'styled-components';

export const Container = styled.a`
  width: 91%;
  height: 3.5rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 16px;
  text-decoration: none;
  z-index: 1;
  color: red;
  opacity: 1;
  overflow: hidden;
  transition: z-index .3s, ease all .3s;
  &:hover {
    background-color: #E5E5E540;
    border-radius: 10px;
  }
  &.hidden {
    z-index: -1;
    opacity: 0;
    overflow: hidden;
  }
  &.none {
    display: none;
  }
  &.show {
    transition: ease opacity .3s;
    opacity: 1;
    z-index: 0;
  }
`;

export const Content = styled.span`
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.5rem;
  color: #272848;
  &.show {
    color: transparent;
  }
`;